import SignIn from './components/SignIn'
import Store from '../store'
import AuthView from './views/AuthView'

import { ConsoleLogger as Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'

const logger = new Logger('AuthRouter')

const AuthRouter = {
  path: '/auth',
  name: 'auth',
  component: AuthView,
  children: [
    {
      path: 'signin',
      name: 'auth_SignIn',
      component: SignIn
    }
  ]
}

const AuthFilter = (to, from, next) => {
  logger.debug('before routing ', to, from)
  Auth.currentAuthenticatedUser()
    .then(user => {
      logger.debug('...has user', user)
      Store.commit('auth/setUser', user)
      next()
    })
    .catch(err => {
      logger.debug('...no user', err)
      Store.commit('auth/setUser', null)
      if (!to.name || !to.name.startsWith('auth') || to.name === 'auth') {
        next('/auth/signin')
      } else {
        next()
      }
    })
}

export default AuthRouter
export { AuthFilter }
